import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "../styles/NFTCard.css";
import Card from "./base/Card";
import CacheImage from "./base/CacheImage";

const ProjectCard = ({ collectionInfo, projectIndex, onClick }) => {
  const [colors, setColors] = useState([]);
  const getColors = colors => {
    setColors(c => [...c, ...colors]);
  }
  
  return (
    <Card
      blurColor={colors[0]}
      onClick={onClick}
      aria-label={`Project #${projectIndex}`}
      child={<>
        <CacheImage 
          imageID={collectionInfo.projectId * 1000000 + projectIndex} 
          contractAddress={collectionInfo.contractAddress}
          getColors={getColors}
        />
        <div className="wrapper">
            <p className="name">#{projectIndex}</p>
        </div>
      </>}>

    </Card>
  );
};

ProjectCard.propTypes = {
  collectionInfo: PropTypes.shape({
    projectId: PropTypes.number,
  }).isRequired,
  projectIndex: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ProjectCard;

